// TYPES --------------------
// valid HTTP method names
export type Method = 'GET' | 'PATCH' | 'POST' | 'PUT' | 'DELETE'

export type HeadersType = { [key: string]: string }
export type BodyType = { [key: string]: any }
export type ParamsType = { [key: string]: any }
export type IdsType = string | string[]
export type MaybeIdsType = IdsType | null

// Subset of request options that are configurable as broad
// (app-wide, resource-wide) defaults
export type ApiOptions = {
  headers?: HeadersType
  params?: ParamsType
  paramSerializationOptions?: qs.IStringifyOptions
}

export type RequestOptions = ApiOptions & {
  body?: BodyType
  file?: File | null
  noCache?: boolean
}

// CONSTANTS --------------------
export const NO_CACHE = 'no-cache'
export const TEN_MINUTE_CACHE = 'public, max-age=600'
export const THIRTY_MINUTE_CACHE = 'public, max-age=1800'
